import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from '../actions';

export const FETCH_PAYPAL_BATCHES = 'FETCH_PAYPAL_BATCHES';
export const REQUEST_PAYPAL_BATCHES = 'REQUEST_PAYPAL_BATCHES';
export const SUCCESS_PAYPAL_BATCHES = 'SUCCESS_PAYPAL_BATCHES';
export const FAILURE_PAYPAL_BATCHES = 'FAILURE_PAYPAL_BATCHES';

export const fetchPaypalBatches = (pageable: PageableQueryParams) => action(FETCH_PAYPAL_BATCHES, { pageable });
export const requestPaypalBatches = () => action(REQUEST_PAYPAL_BATCHES);
export const requestPaypalBatchesSuccess = (response: any) => action(SUCCESS_PAYPAL_BATCHES, { response });
export const requestPaypalBatchesFailure = (error: any) => action(FAILURE_PAYPAL_BATCHES, { error });

export const FETCH_PAYPAL_BATCH_FILE_DETAILS = 'FETCH_PAYPAL_BATCH_FILE_DETAILS';
export const REQUEST_PAYPAL_BATCH_FILE_DETAILS = 'REQUEST_PAYPAL_BATCH_FILE_DETAILS';
export const SUCCESS_PAYPAL_BATCH_FILE_DETAILS = 'SUCCESS_PAYPAL_BATCH_FILE_DETAILS';
export const FAILURE_PAYPAL_BATCH_FILE_DETAILS = 'FAILURE_PAYPAL_BATCH_FILE_DETAILS';

export const fetchPaypalBatchFileDetails = (paypalBatchFileId: string) =>
    action(FETCH_PAYPAL_BATCH_FILE_DETAILS, { paypalBatchFileId });
export const requestPaypalBatchFileDetails = () => action(REQUEST_PAYPAL_BATCH_FILE_DETAILS);
export const requestPaypalBatchFileDetailsSuccess = (response: any) =>
    action(SUCCESS_PAYPAL_BATCH_FILE_DETAILS, { response });
export const requestPaypalBatchFileDetailsFailure = (error: any) =>
    action(FAILURE_PAYPAL_BATCH_FILE_DETAILS, { error });

export const FETCH_PAYPAL_UNASSIGNED_ORDERS = 'FETCH_PAYPAL_UNASSIGNED_ORDERS';
export const REQUEST_PAYPAL_UNASSIGNED_ORDERS = 'REQUEST_PAYPAL_UNASSIGNED_ORDERS';
export const SUCCESS_PAYPAL_UNASSIGNED_ORDERS = 'SUCCESS_PAYPAL_UNASSIGNED_ORDERS';
export const FAILURE_PAYPAL_UNASSIGNED_ORDERS = 'FAILURE_PAYPAL_UNASSIGNED_ORDERS';

export const fetchPaypalUnassignedOrders = (paypalBatchFileDetailId: string) =>
    action(FETCH_PAYPAL_UNASSIGNED_ORDERS, { paypalBatchFileDetailId });
export const requestPaypalUnassignedOrders = () => action(REQUEST_PAYPAL_UNASSIGNED_ORDERS);
export const requestPaypalUnassignedOrdersSuccess = (response: any) =>
    action(SUCCESS_PAYPAL_UNASSIGNED_ORDERS, { response });
export const requestPaypalUnassignedOrdersFailure = (error: any) => action(FAILURE_PAYPAL_UNASSIGNED_ORDERS, { error });

export const ASSIGN_BATCH_FILE_TO_ORDER = 'ASSIGN_BATCH_FILE_TO_ORDER';
export const REQUEST_ASSIGN_BATCH_FILE_TO_ORDER = 'REQUEST_ASSIGN_BATCH_FILE_TO_ORDER';
export const SUCCESS_ASSIGN_BATCH_FILE_TO_ORDER = 'SUCCESS_ASSIGN_BATCH_FILE_TO_ORDER';
export const FAILURE_ASSIGN_BATCH_FILE_TO_ORDER = 'FAILURE_ASSIGN_BATCH_FILE_TO_ORDER';

export const assignBatchFileToOrder = (paypalBatchFileDetailId: string, orderId?: number | undefined) =>
    action(ASSIGN_BATCH_FILE_TO_ORDER, { paypalBatchFileDetailId, orderId });
export const requestAssignBatchFileToOrder = () => action(REQUEST_ASSIGN_BATCH_FILE_TO_ORDER);
export const requestAssignBatchFileToOrderSuccess = (response: any) =>
    action(SUCCESS_ASSIGN_BATCH_FILE_TO_ORDER, { response });
export const requestAssignBatchFileToOrderFailure = (error: any) =>
    action(FAILURE_ASSIGN_BATCH_FILE_TO_ORDER, { error });
